<template>
  <div id="layout-template-storage-location" v-if="showStorageLocations()">
    <el-row class="default-section-header">
      <el-col
        class="default-section-title"
      >{{ $t('layoutTemplate.storageLocationTitle') }}</el-col>
    </el-row>

    <div>
      <el-form
        class="search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.area')">
              <el-select v-model="searchForm.area" @change="handleSearch">
                <el-option
                  v-for="item in areaOptions"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item :label="$t('layoutTemplate.shipperGroup')">
              <shipper-group-select v-model="searchForm.shipperGroupId" @change="handleSearch" :includeOptionAll="true" />
            </el-form-item>
          </el-col>
          <el-col :span="2" class="text-align-end">
            <el-tooltip
              :content="$t('common.search')"
              class="button-action-default-tooltip"
              effect="dark"
              placement="top-start"
            >
              <el-button
                class="button-action-default"
                @click="handleSearch()"
                icon="el-icon-search"
                size="mini"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-row :gutter="10">
      <el-col class="text-align-end">
        <el-button
          id="print-layout-button"
          class="button-action-default add-storage-location-margin-bottom"
          size="mini"
          type="success"
          plain
          style="margin-right: 10px"
          @click="handlePrint"
        >{{ $t('layoutTemplate.printLayout') }}</el-button>
        <add-storage-location
          :layoutTemplateId="layoutTemplateId"
          :layoutType="layoutType"
          :layoutTemplateName="layoutTemplateName"
          @searchStorageLocations="handleSearch()" />
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col>
        <el-form :model="editForm" :rules="editFormRules" ref="editForm">
          <el-table
            :data="storageLocation.list"
            v-loading="storageLocation.loadingSearch"
            size="mini"
            tooltip-effect="dark"
            class="dark-blue-table"
            :empty-text="$t('common.notAbleToFindRecords')"
            stripe
          >
            <el-table-column
              prop="storageLocation"
              :label="$t('layoutTemplate.storageLocation')"
              :min-width="5"
              align="center"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-form-item prop="code">
                    <el-input v-model="editForm.code" maxlength="50"></el-input>
                  </el-form-item>
                </template>
                <template v-else>
                  <span>{{scope.row.code}}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="area"
              :label="$t('layoutTemplate.area')"
              :min-width="5"
              align="center"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-form-item prop="area">
                    <el-select
                      v-model="editForm.areaName"
                      id="editForm-area"
                      ref="filter-area"
                      @change="handleChange"
                    >
                      <el-option
                      v-for="item in areaOptionsWithoutAll"
                      :key="item.value"
                      :label="$t(item.label)"
                      :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <template v-else>
                  <span>{{ $t(getAreaName(scope.row.area)) }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="shipperGroupName"
              :label="$t('layoutTemplate.shipperGroup')"
              :min-width="5"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="positionsAllocated"
              :label="$t('layoutTemplate.positionsAssigned')"
              :min-width="5"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.positionsAssigned }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="options" :label="$t('common.options')" :min-width="5" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="showEditButton(scope.row)"
                  class="item"
                  effect="dark"
                  :enterable="false"
                  :content="$t('warehouse.orderEntry.edit')"
                  placement="top-start"
                >
                  <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
                </el-tooltip>
                <template v-else-if="scope.row.edit">
                  <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate(scope.row)"></el-button>
                  <el-button icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)"></el-button>
                </template>
                <template v-if="!scope.row.edit">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :enterable="false"
                    :content="$t('layoutTemplate.storageLocationdetails')"
                    placement="top-start"
                  >
                    <i class="el-icon-search icon-action" size="mini" icon="el-icon-plus" @click="handleViewPositions(scope.row)"></i>
                  </el-tooltip>
                  <el-tooltip
                          v-if="showEditButton(scope.row)"
                          class="item"
                          effect="dark"
                          :enterable="false"
                          :content="$t('warehouse.orderEntry.delete')"
                          placement="top-start"
                  >
                    <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="pagination-footer" v-show="storageLocation.total > 0">
          <span class="el-pagination__total">
            <span class="el-pagination__title">{{ $t('common.total') }}</span>
            {{ storageLocation.total }}
          </span>
          <el-pagination
            @size-change="handleSearchChangeLimit"
            :page-sizes="sizes"
            :page-size="storageLocation.actualFilters.rows"
            :current-page.sync="storageLocation.actualFilters.page"
            @current-change="handleSearchChangePage"
            :total="storageLocation.total"
            layout="sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message, Loading } from 'element-ui';
import constants from '@/utils/constants';
import ShipperGroupSelect from '@/components/ShipperGroup/ShipperGroupSelect';
import AddStorageLocation from './AddStorageLocation';

const storageLocationSetEditingAction = 'storageLocation/setEditing';

export default {
  name: 'StorageLocation',
  components: {
    AddStorageLocation, ShipperGroupSelect
  },
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    layoutType: {
      type: Number,
      required: true
    },
    layoutTemplateName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['storageLocation']),
    areaOptionsWithoutAll() {
      return constants.LAYOUT_TEMPLATE.AREA_OPTIONS.filter(option => option.value > 0);
    }
  },
  watch: {
    layoutTemplateId() {
      this.searchForm.shipperGroupId = null;
      this.handleSearch();
    }
  },
  data() {
    return {
      editForm: {
        id: null,
        code: null,
        area: null,
        areaName: null,
        layoutTemplateId: null
      },
      editFormRules: {
        code: [
          {
            required: true,
            message: this.$t('layoutTemplate.error.codeRequired'),
            trigger: 'blur'
          }
        ]
      },
      searchForm: {
        layoutTemplateId: 0,
        area: constants.LAYOUT_TEMPLATE.AREA_OPTIONS[0].value,
        shipperGroupId: null
      },
      areaOptions: constants.LAYOUT_TEMPLATE.AREA_OPTIONS,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSearch() {
      this.searchForm.layoutTemplateId = this.layoutTemplateId;
      this.$store.dispatch(
        'storageLocation/search',
        this.searchForm
      );
      this.$emit('cleanStorageLocation');
    },
    handleSearchChangePage(val) {
      Object.assign(this.searchForm, { page: val });
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      Object.assign(this.searchForm, {
        rows: val,
        page: constants.TABLES.DEFAULT_PAGE
      });
      this.handleSearch();
    },
    getAreaName(areaId) {
      const selectedArea = constants.LAYOUT_TEMPLATE.AREA_OPTIONS.find(
        area => area.value === areaId
      );

      if (selectedArea) {
        return selectedArea.label;
      }

      return 'layoutTemplate.areaLabels.invalidArea';
    },
    handleDelete(row) {
      const message = this.$t('layoutTemplate.deleteLocationConfirmMessage')
        .replace('[locationCode]', row.code)
        .replace('[area]', row.areaEnum)
        .replace('[countPositions]', row.positionsAssigned);
      this.$confirm(message, { dangerouslyUseHTMLString: true, confirmButtonText: this.$t('common.yes') })
        .then(() => {
          this.deleteLocation(row);
        }).catch(() => {});
    },
    handleViewPositions(row) {
      const storageLocationToEmit = {
        layoutTemplateId: this.layoutTemplateId,
        storageLocationId: row.id,
        storageLocation: row.code,
        area: this.$t(this.getAreaName(row.area)),
        shipperGroupName: row.shipperGroupName,
        positionsAssigned: row.positionsAssigned
      };

      this.$emit('loadStoragePosition', storageLocationToEmit);
    },
    showStorageLocations() {
      return (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.TEMPLATE && this.$can(this.permissions.WAREHOUSE.VIEW_LAYOUT_TEMPLATES))
          || (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.LAYOUT && this.$can(this.permissions.WAREHOUSE.VIEW_LAYOUTS));
    },
    handleEdit(row) {
      this.$store.dispatch(storageLocationSetEditingAction, true);
      row.edit = true;
      this.editForm.id = row.id;
      this.editForm.code = row.code;
      this.editForm.area = row.area;
      this.editForm.areaName = this.$t(this.getAreaName(row.area));
      this.editForm.layoutTemplateId = row.layoutTemplateId;
    },
    handleChange(id) {
      this.editForm.area = id;
    },
    cancelEdit(row) {
      this.$store.dispatch(storageLocationSetEditingAction, false);
      row.edit = false;
    },
    handleUpdate() {
      this.$refs.editForm.validate((valid, validationsErrors) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('storageLocation/update', { locationToUpdate: this.editForm, locationId: this.editForm.id })
            .then((response) => {
              loading.close();
              this.handleSearch();
              this.$store.dispatch(storageLocationSetEditingAction, false);
              this.$message.success(response.message);
            })
            .catch(() => {
              loading.close();
            });
        } else {
          let errorMessage = '';
          Object.keys(validationsErrors).forEach((key) => {
            validationsErrors[key].forEach((validation) => {
              errorMessage += `${validation.message}. `;
            });
          });
          this.$message.warning(errorMessage);
        }
      });
    },
    deleteLocation(row) {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('storageLocation/delete', row.id).then((response) => {
        this.$emit('cleanStorageLocation');
        this.handleSearch();
        loading.close();
        this.$message.success(response.message);
      })
        .catch(() => {
          loading.close();
        });
    },
    showEditButton(row) {
      return (
        ((this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.TEMPLATE && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUT_TEMPLATES))
            || (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.LAYOUT && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUTS)))
        && !this.storageLocation.isEditing
        && !row.edit
      );
    },
    async handlePrint() {
      const loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
      await this.$store.dispatch('storageLocation/print', this.searchForm);
      loading.close();
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
div#layout-template-storage-location {
  .default-section-title {
    font-size: 18px;
    padding-left: 0px;
    text-align: left;
  }

  .search-section-form {
    .el-input__inner {
      height: 28px;
    }

    .el-icon-search {
      font-size: 12px;
    }
  }

  .el-table__empty-text {
    width: 100%;
  }

  th {
    line-height: 1.15;
    .cell {
      line-height: 16px;
      height: 16px;
    }
  }
}
</style>
